import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import Input from '../components/form/Input';
import { ReactComponent as PassportLogo } from '../svg/passport_logo.svg';
import { useHistory } from 'react-router-dom';
import { useQueryStringParam } from '../utils/routing';
import { LoginFooter } from './Login';

const forgotPassword = (email) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/unauthorized/forgotpassword`,
        method: 'POST',
        data: {
            username: email
        }
    });
};

const ForgotPassword = ({ router = {} }) => {
    const email = useQueryStringParam('email');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState(false);
    const history = useHistory();
    const { values, setFieldValue } = useFormik({
        initialValues: {
            email: email || ''
        }
    });

    const processLogin = async (event) => {
        event.preventDefault();
        setIsSending(true);
        try {
            await forgotPassword(values.email);
            history.push({ pathname: '/reset-password', search: `?email=${values.email}` });
        } catch (err) {
            console.error(err);
            setError(true);
            setIsSending(false);
        }
    };

    return (
        <div className="page-signin">
            <form className="form-signin" onSubmit={processLogin} noValidate>
                <Link to="/" className="d-block mb-4">
                    <PassportLogo />
                </Link>
                <p>
                    Enter your email and click send. We will send you a verification code to use when setting your new
                    password.
                </p>
                <Input
                    label="Email"
                    type="email"
                    id="email"
                    value={values.email}
                    autoComplete="email"
                    isRequiredMsg="Email is required."
                    required
                    autoFocus
                    onChange={(id, value) => setFieldValue('email', value)}
                />
                {error && (
                    <div className="alert alert-danger">
                        {
                            <p>
                                If you are experiencing an error, please make sure your email is verified, you should
                                have received an email with the link to do so. If you can not find the email, please use
                                our{' '}
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://support.passport.inaudio.com/support/home"
                                >
                                    support portal
                                </a>{' '}
                                to request another email.
                            </p>
                        }
                    </div>
                )}
                <button className="btn btn-primary btn-block" type="submit" disabled={isSending}>
                    Send
                </button>
            </form>
            <LoginFooter />
        </div>
    );
};

export default ForgotPassword;
